import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Store } from '@ngrx/store';

import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { UserApiActions } from '../../@store/user/user.actions';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private store = inject(Store);
  private snackBar = inject(MatSnackBar);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        // Check if it's a successful response
        if (event instanceof HttpResponse) {
          if (event.status === 201) {
            console.info('✅ Resource created successfully.');
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 401:
              console.error('❌ Unauthorized. Please log in.');
              this.store.dispatch(UserApiActions.logout());
              break;
            case 403:
              console.error('❌ Forbidden. You do not have access to this resource.');
              break;
            case 404:
              console.error('❌ Resource not found.');
              break;
            case 422:
              console.warn('⚠️ Validation failed on the server.');
              break;
            case 429:
              console.warn('⚠️ Too many requests. Rate limit exceeded.');
              break;
            case 500:
              console.error('❌ Server error. Please try again later.');
              break;
            default:
              console.error(`❌ Unexpected error: ${error.status}`);
          }

          // Display snackbar with formatted error messages
          const errorsObj = error?.error?.errors;
          if (errorsObj && typeof errorsObj === 'object' && !Array.isArray(errorsObj)) {
            const errorMessage = Object.values(errorsObj).join('\n');

            this.snackBar.open(errorMessage, 'Close', {
              duration: 6000,
              panelClass: ['snackbar-error', 'whitespace-pre-line'],
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
            });
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
